import { render } from "./RegisterCompany.vue?vue&type=template&id=63f5401e&scoped=true"
import script from "./RegisterCompany.js?vue&type=script&lang=js"
export * from "./RegisterCompany.js?vue&type=script&lang=js"

import "./RegisterCompany.scss?vue&type=style&index=0&id=63f5401e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f5401e"]])

export default __exports__